import * as React from 'react';
import Button from '../../Button';

export default function PickerButton(props) {
    return <Button size="small" type="primary" {...props} />;
}
